import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-stove",
  "use": "icon-si-glyph-stove-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-stove\" id=\"icon-si-glyph-stove\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>995</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M0,0 L0,3 L14.958,3 L14.958,0 L0,0 L0,0 Z M2,2 L1,2 L1,1 L2,1 L2,2 L2,2 Z M4,2 L3,2 L3,1 L4,1 L4,2 L4,2 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M0,16 L14.958,16 L14.958,4.042 L0,4.042 L0,16 L0,16 Z M4,6 L11,6 L11,7 L4,7 L4,6 L4,6 Z M3,7.958 L12,7.958 L12,13.958 L3,13.958 L3,7.958 L3,7.958 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-stove.svg
// module id = SUc6
// module chunks = 62